import React from 'react';
import './BasePage.css';

/**
 * BasePage Component
 *
 * A reusable base page component that provides consistent structure for all pages.
 * This ensures proper alignment and layout across the entire application.
 *
 * @param {string} title - The page title (e.g., "PRODUCTION MANAGEMENT")
 * @param {string} icon - The icon/emoji for the page (e.g., "🏭")
 * @param {ReactNode} children - The content of the page
 * @param {string} className - Optional additional class name for the page wrapper
 */
function BasePage({ title, icon, children, className = '' }) {
  return (
    <div className="page-content">
      <div className="page-header">
        <h1 className="page-title">
          {icon && <span className="page-icon">{icon}</span>}
          {title}
        </h1>
      </div>
      <div className={`base-page ${className}`}>
        {children}
      </div>
    </div>
  );
}

export default BasePage;